import { render, staticRenderFns } from "./pets.vue?vue&type=template&id=18aadaf6&scoped=true&"
import script from "./pets.vue?vue&type=script&lang=js&"
export * from "./pets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aadaf6",
  null
  
)

export default component.exports